import React from 'react';
import cn from 'classnames';

import { EActionButtonTypes, TActionButtonTypes } from '@enums/common';

import styles from './ActionButton.module.scss';

interface IActionButton {
	text: string;
	style: TActionButtonTypes;
	onClick: () => void;
}

const ActionButton = ({
	text,
	style,
	onClick,
}: IActionButton) => {
	const buttonClasses = cn(styles.button, {
		[styles.approve]: style === EActionButtonTypes.approve,
		[styles.disapprove]: style === EActionButtonTypes.disapprove,
		[styles.revoke]: style === EActionButtonTypes.revoke,
	});

	return (
		<div
			className={buttonClasses}
			onClick={onClick}
		>
			{text}
		</div>
	);
};

export default ActionButton;
